// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.active[data-v-92d35534] {\n\tcolor: var(--main-blue-3);\n\tborder-left: 5px solid var(--main-blue-3);\n\tpadding-left: 12px;\n}\n.root[data-v-92d35534] {\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\theight: 100%;\n\tmargin-top: 5px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
